import React, { useState } from 'react';
import { 
  Box, 
  Typography, 
  Paper, 
  Divider,
  Tabs,
  Tab,
  Alert
} from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import UpdateDivesitePage from '../../../pages/Updatesite.js';
import DivesiteForm from '../../NewDivesite/DivesiteForm.js'; // Import the form component
import { useAuth } from "../../../contexts/AuthContext.js"; // Adjust path as needed
import auth from "../../../config/firebase.js"; // Adjust path as needed
import StubEditorPage from './AdminStubListPage.js'; // Import the stub editor page


// Create a TabPanel component for tab content
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`divesite-tabpanel-${index}`}
      aria-labelledby={`divesite-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

const DivesiteAdmin = ({ setError, setSuccess }) => {
  const [tabValue, setTabValue] = useState(0);
  const { userObjectId } = useAuth();

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

const handleStubSubmission = async (formData) => {
    console.log("Sending request to:", '/api/divesitestubs');
    console.log("Request method:", 'POST');
    
    try {
      // Get the authentication token
      const user = auth.currentUser;
      const token = user && (await user.getIdToken());
      
      if (!token) {
        throw new Error("Authentication required");
      }

      // Log the formData to see what's being sent
      console.log("FormData entries:");
      for (let pair of formData.entries()) {
        console.log(pair[0] + ': ' + (pair[0] === 'divesitedata' ? '[Object]' : pair[1]));
      }

      // Send to the correct endpoint with proper headers
      const response = await fetch('/api/divesitestubs', {
        method: 'POST',
        body: formData, // Keep using FormData
        headers: {
          Authorization: `Bearer ${token}`
          // Don't set Content-Type when using FormData - the browser will set it with the boundary
        }
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error("Error response:", errorData);
        throw new Error(errorData.message || 'Failed to create divesite bounty');
      }

      const data = await response.json();
      setSuccess('Divesite bounty created successfully! It will be reviewed before publishing.');
      return data;
    } catch (error) {
      console.error("Bounty submission error:", error);
      setError(error.message || 'Error creating divesite bounty');
      throw error;
    }
  };



  return (
    <Box>
      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6" gutterBottom>
          <LocationOnIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
          Divesite Management
        </Typography>
        <Divider sx={{ mb: 2 }} />
        
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={tabValue} onChange={handleTabChange} aria-label="divesite admin tabs">
            <Tab label="Edit Existing Divesites" />
            <Tab label="Create Divesite Bounty" />
            <Tab label="Manage Divesite Bounties" />
          </Tabs>
        </Box>
        
        <TabPanel value={tabValue} index={0}>
          {/* Original update functionality */}
          <UpdateDivesitePage />
        </TabPanel>
        
        <TabPanel value={tabValue} index={1}>
          {/* New stub creation functionality */}
          <Box sx={{ mb: 3 }}>
            <Alert severity="info" sx={{ mb: 2 }}>
              Create a divesite bounty for community review. Once approved, it will be published to the main divesite collection.
            </Alert>
            
            {/* Use the existing DivesiteForm but with custom submission handler */}
            <DivesiteForm 
              isStubMode={true} 
              onStubSubmit={handleStubSubmission}
              stubModeText="You are creating a divesite bounty for review"
            />
          </Box>
        </TabPanel>
<TabPanel value={tabValue} index={2}>
  <Box sx={{ mb: 3 }}>
    <Alert severity="info" sx={{ mb: 2 }}>
      Edit existing divesite bounties... You can update details, approve bounties for publication, or reject them.
    </Alert>
    
    <StubEditorPage 
      setError={setError} 
      setSuccess={setSuccess}
      isAdminMode={true}        // Enable admin features
      showAllStubs={true}       // Show all stubs, not just user's
    />
  </Box>
</TabPanel>
      </Paper>
    </Box>
  );
};

export default DivesiteAdmin;
